var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHcIconFamilyCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hc-icon-family-condition_svg__Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33A3DC",
    d: "M21.8 180c-2.8 0-5.3-2.1-5.6-5-.2-1.2-3.5-30.6 22.7-53.1 25.3-21.7 55.7-14.5 59.1-13.6 2.5.5 19.4 4.3 33.4 19.9 16.8 18.8 16.6 40.2 16.2 46.4-.2 3.1-2.9 5.5-6.1 5.2-3.1-.2-5.5-3-5.2-6.1.4-5 .5-22.5-13.3-38-12-13.5-27-16.4-27.2-16.4-.2 0-.4-.1-.5-.1-.3-.1-27.4-7.3-48.9 11.2-21.7 18.6-18.9 42.9-18.9 43.1.4 3.1-1.8 5.9-4.9 6.3-.3.1-.6.2-.8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33A3DC",
    d: "M81.8 56.3c13.4 0 24.3 10.9 24.3 24.3S95.2 105 81.8 105c-13.5 0-24.4-11-24.4-24.4s10.9-24.3 24.4-24.3m0-11.3c-19.7 0-35.7 16-35.7 35.7s16 35.7 35.7 35.7c19.7 0 35.7-16 35.7-35.7S101.4 45 81.8 45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33A3DC",
    d: "M178.3 118.2h-.4c-3.1-.2-5.5-3-5.2-6.1.2-2.4.6-15.1-9.1-26-8.2-9.2-18.4-11.2-18.5-11.2-.2 0-.4-.1-.5-.1-.1 0-14-3.7-27.2 3.4-2.8 1.5-6.2.4-7.7-2.3-1.5-2.8-.4-6.2 2.3-7.7 16.4-8.8 33-5 35.4-4.3 2.1.4 14.5 3.4 24.7 14.8 12.5 14 12.3 29.8 12 34.4-.4 2.8-2.9 5.1-5.8 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33A3DC",
    d: "M135.2 31.4c7.8 0 14.2 6.4 14.2 14.2s-6.4 14.2-14.2 14.2c-7.8 0-14.2-6.4-14.2-14.2s6.4-14.2 14.2-14.2m0-11.4c-14.1 0-25.5 11.4-25.5 25.5S121.1 71 135.2 71s25.5-11.4 25.5-25.5c0-14-11.4-25.5-25.5-25.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F8AE15",
    d: "M89.4 169.1h-15c-2.2 0-3.9-1.8-3.9-3.9v-5.5H65c-2.2 0-3.9-1.8-3.9-3.9v-15c0-2.2 1.8-3.9 3.9-3.9h5.5v-5.5c0-2.2 1.8-3.9 3.9-3.9h15c2.2 0 3.9 1.8 3.9 3.9v5.5h5.6c2.2 0 3.9 1.8 3.9 3.9v15c0 2.2-1.8 3.9-3.9 3.9h-5.5v5.5c-.1 2.2-1.8 3.9-4 3.9zm-11-7.8h7.1v-5.5c0-2.2 1.8-3.9 3.9-3.9h5.5v-7.2h-5.6c-2.2 0-3.9-1.8-3.9-3.9v-5.5h-7.1v5.5c0 2.2-1.8 3.9-3.9 3.9h-5.5v7.1h5.6c2.2 0 3.9 1.8 3.9 3.9v5.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcIconFamilyCondition);
export default ForwardRef;